import { render, staticRenderFns } from "./TemplateMailViewGlobal.vue?vue&type=template&id=649a27e5&scoped=true"
import script from "./TemplateMailViewGlobal.vue?vue&type=script&lang=js"
export * from "./TemplateMailViewGlobal.vue?vue&type=script&lang=js"
import style0 from "./TemplateMailViewGlobal.vue?vue&type=style&index=0&id=649a27e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649a27e5",
  null
  
)

export default component.exports